module.exports = __webpack_public_path__ + "static/media/x-ray.66002c2c.svg";